import { render } from "./InputRupiah.vue?vue&type=template&id=3ff3c806"
import script from "./InputRupiah.vue?vue&type=script&lang=js"
export * from "./InputRupiah.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__